const CardValidator = require('card-validator');

const getFormattedCvvCode = (cvvCode: string, cardNumber: string) => {
  const cardInfo = CardValidator.number(cardNumber);
  const defaultMaxLength = 3;
  const maxLength = cardInfo?.card?.code?.size || defaultMaxLength;

  const formattedCvvArray = [];
  if (cvvCode) {
    const cvvArray = cvvCode.split('');
    for (let i = 0; i < cvvArray.length; i++) {
      if (i < maxLength) {
        formattedCvvArray.push(cvvCode[i].replace(/\D/g, ''));
      }
    }
  }
  return formattedCvvArray.join('');
};

export default getFormattedCvvCode;
